import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  AppConstant,
  HTTP_CONTEXT,
  RESPONSE_CODE,
} from 'src/app/helper/class/app-constant';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StaffApiService {
  constructor(
    private http: HttpClient,
    private downloadHelper: downloadHelper
  ) { }

  saveStaffDetails(data: any) {
    return lastValueFrom(this.http.post(`/staff/saveStaff`, data));
  }
  saveStaffNoc(id, data: any) {
    return lastValueFrom(this.http.post(`/staff/saveNoc/${id}`, data));
  }
  getStaffDetails(id: any) {
    return lastValueFrom(this.http.get(`/staff/getDetail/${id}`));
  }
  getStaffAddress(id: any) {
    return lastValueFrom(this.http.get(`/staff/getAddressByEmpId/${id}`));
  }
  searchStaff(w: any = {}) {
    return lastValueFrom(this.http.post(`staff/search`, w));
  }

  updateRequest(id: string | number | Array<any>, data: any) {
    if (Array.isArray(id)) {
      id = id.join(',');
    }
    return lastValueFrom(this.http.post(`/staff/updateRequest/${id}`, data));
  }

  reliveStaff(id: any, data: any) {
    return lastValueFrom(this.http.post(`/staff/relive/${id}`, data));
  }

  getSaffViews(id: any) {
    return lastValueFrom(this.http.get(`/staff/getViewDetails/${id}`));
  }
  getList(
    ev: any,
    type: 'DELETED' | 'ACTIVE' | 'RETIRED' | 'OVERDUE' | 'EXTEND' = 'ACTIVE'
  ) {
    return lastValueFrom(this.http.post(`/staff/getList/${type}`, ev));
  }
  getStaffByCross(id: string | number) {
    return lastValueFrom(this.http.get(`/staff/getByCross/${id}`));
  }
  getStaffDetailWithAddress(id: string | number) {
    return lastValueFrom(this.http.get(`/staff/getDetailAddress/${id}`));
  }
  getFamilyByStaff(id: string | number) {
    //strict one 
    id =  typeof id == 'number' ?  id :  id.split(',')[0]; 
    return lastValueFrom(this.http.get(`/staff/getFamilyByStaff/${id}`));
  }
  getFamilyWithAddress(id: string | number) {
    return lastValueFrom(this.http.get(`/staff/getFamilyWithAddress/${id}`));
  }
  getRememberAll(ev: any = {}, type = 'BIRTHDAY', cat = '0') {
    return lastValueFrom(
      this.http.post(`/staff/getRememberAll/${type}/${cat}`, ev)
    );
  }
  getListLog(ev: any = {}) {
    const lasyP = '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`/staff/getLogList${lasyP}`));
  }
  
  //Gems Exp
  getActiveExp(id: any) {
    return lastValueFrom(this.http.get(`/staff/getActiveExp/${id}/true`));
  }
  getAllExp(id: any) {
    return lastValueFrom(this.http.get(`/staff/getAllExp/${id}`));
  }

  getBasic(id: any, isFull = false) {
    return lastValueFrom(this.http.get(`/staff/getBasic/${id}/${isFull}`));
  }

  //Transfer Started
  saveStaffTransfer(data: any) {
    return lastValueFrom(this.http.post(`/staffTransfer/save`, data));
  }
  getListTransfer(ev: any) {
    return lastValueFrom(this.http.post(`/staffTransfer/getList`, ev));
  }

  getTransferByid(id: any) {
    return lastValueFrom(this.http.get(`/staffTransfer/getById/${id}`));
  }

  //dedication
  getDedicationList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.post(`/dedication/getList`, ev));
  }

  getDedicationByid(id: any) {
    return lastValueFrom(this.http.get(`/dedication/getById/${id}`));
  }
  saveDedication(data: any) {
    return lastValueFrom(this.http.post(`/dedication/save`, data));
  }
  approveReject(id: any, data: any) {
    return lastValueFrom(this.http.post(`/dedication/approveReject/${id}`, data));
  }
  sentDedicationMail(id: any) {
    return lastValueFrom(this.http.get(`/dedication/sentMail/${id}`));
  }

  download(id: any,tempName: string = 'profile', data: any = {}) {
    const url = `/staff/download/${id}/${tempName}`;
    const fileName = `${data.name || ''}-${data.staff_emp_id || ''}` || '';
    return this.downloadHelper.downloadApi(url, 'GET', fileName);
  }

  
  getStaffPayroll(id) {
    return lastValueFrom(
      this.http.get(`${environment.payrollUrl}/getStaffBasicPayroll/${id}`)
    );
  }

  exportBirthday(ev: any, type: any, cat: any) {
    const url = `/staff/exportRemember/${type}/${cat}`;
    const fileName = `${AppConstant.ORG_NAME}-STAFF-${type}` || '';
    return this.downloadHelper.downloadApi(url, 'POST', fileName, ev);
  }
  checkRequestExists = (data: any): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      console.log(data);
      if (+(data.modify_request || 0) == 1) {
        resolve(false);
        return;
      }
      this.getBasic(data.staff_emp_id)
        .then((res: ResponseData | any) => {
          if (res.statusCode == RESPONSE_CODE.SUCCESS) {
            if (res.result) {
              if (+res?.result?.modify_request == 0) {
                resolve(true);
              }
            }
          }
          resolve(false);
        })
        .catch((err) => {
          reject(true);
        });
    });
  };
}
